import GridCampaignCard from '@/components/layout/GridCampaignCard';
import Loader from '@/components/Loader';
import { MediaCardVertical } from '@/components/MediaCardVertical';
import BaseLayout from '@/layout/BaseLayout';
import { trpc } from '@/trpcClient';
import type { ListMediaFilterTypeWithValues } from '@shelflix/schemas/media/list';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { MediaListFilter } from './MediaListFilter';

export function MediaList() {
  const [filters, setFilters] = useState<ListMediaFilterTypeWithValues>({});

  const location = useLocation();
  const brandName = location.state?.brandName ?? 'Marca';

  const { brandUuid } = useParams<{ brandUuid: string }>();

  const { data, isLoading, isError } = useQuery(
    trpc.media.list.queryOptions({
      brandUuid,
      recordsPerPage: 500,
      ...(filters.search?.value && { search: { ...filters.search } }),
      ...(filters.filter && { filter: filters.filter.map((f) => ({ ...f.field })) }),
      ...(filters.sort && { sort: filters.sort }),
    })
  );

  const medias = data?.medias ?? [];

  return (
    <BaseLayout>
      <section className="flex flex-col gap-8">
        {/* <Summary summaryData={mediaSummaryData} title="Resumo de mídias" /> */}
        <MediaListFilter onChange={setFilters} />

        {isLoading && <Loader message="Carregando marcas..." />}

        {isError && <p className="p-4 text-red-500">Erro ao carregar marcas.</p>}
        {!isLoading && !isError && !!medias.length && (
          <GridCampaignCard>
            {medias.map((media) => (
              <MediaCardVertical key={media.uuid} media={media} brandName={brandName} />
            ))}
          </GridCampaignCard>
        )}
        {!isLoading && !isError && !medias.length && <p className="p-4">Nenhuma mídia cadastrada</p>}

        {/* <TablePagination itemsPerPage={pageSize} page={page} totalItems={totalItems} onPageChange={setPage} /> */}
      </section>
    </BaseLayout>
  );
}
